import { Stack } from '@mui/material';

import { ORDER_STATUS } from './../../../Constant/Enums';

import JobRequestsCard from './JobRequestsCard';

import useJobRequestsSection from '../Services/Hooks/useJobRequestsSection';

const JobRequestsAdvanceSection = () => {
  const { jobRequests, getAndUpdateJobRequests } = useJobRequestsSection(ORDER_STATUS.AWAIT_SERVICE_APPROVAL);
  return (
    <Stack gap={4} maxWidth='500px'>
      {jobRequests.map(props => (
        <JobRequestsCard
          isAdvanceSectionCard
          updateParentJobsRequests={getAndUpdateJobRequests}
          key={props.id}
          {...props}
        />
      ))}
    </Stack>
  );
};

export default JobRequestsAdvanceSection;
